import styled, { css, keyframes } from 'styled-components'
import styledTheme from '../../styles/theme'
import Button from '@material-ui/core/Button'
import { ContainerHeading, ContainerHeadingTextDiv, ContainerHeadingActionIconsDiv, ContainerHeadingActionIcon } from '../../styles/styled-elements'

export { styledTheme, ContainerHeading, ContainerHeadingTextDiv, ContainerHeadingActionIconsDiv, ContainerHeadingActionIcon }

export const Form = styled.form`
  width: 100%;
  padding: 0 40px;
  @media (min-width: 768px) {
    width: 400px;
  }
`
export const FieldsWrapper = styled.div`
  margin: 20px 0;
`
export const FieldDiv = styled.div`
  width: 100%;
  @media (min-width: 768px) {
    margin-bottom: 20px;
  }
`
export const SubmitWrapper = styled.div`
  text-align: center;
  padding: 20px 0;
  @media (min-width: 768px) {
    margin-bottom: 20px;
  }
`
export const DataViewModalContainer = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  bottom: 10px;
  left: 10px;
  right: 10px;
  top: 10px;
  @media (max-width: ${styledTheme.breakpoints.sm}px), (max-height: ${styledTheme.breakpoints.sm}px) {
    bottom: 0px;
    left: 0px;
    right: 0px;
    top: 0px;
  };
  border: 1px solid ${styledTheme.border_grey};
  background-color: #FFF;
  z-index: 30;
`
export const GraphContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  max-height: calc(100% - 40px);
`
export const GraphContainer = styled.div`
  display: inline-flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-height: 100%;
  position: relative;
`

export const GraphOverlayNotice = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  right: 12px;
  top: 8px;
  z-index: 4;
  max-width: min(360px, calc(100% - 24px));

  @media (max-width: ${styledTheme.breakpoints.sm}px) {
    right: 8px;
    top: 8px;
    max-width: calc(100% - 16px);
  }
`

export const GraphOverlayNoticeRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
  width: 100%;

  @media (max-width: ${styledTheme.breakpoints.sm}px) {
    gap: 4px;
  }
`

export const GraphOverlayNoticeButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 999px;
  background-color: rgba(255, 255, 255, 0.94);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  color: #333;
  font-size: 11px;
  line-height: 1.2;
  cursor: pointer;

  @media (max-width: ${styledTheme.breakpoints.sm}px) {
    padding: 5px 8px;
    font-size: 10px;
  }
`

export const GraphOverlayNoticeIcon = styled.span`
  font-size: 12px;
  line-height: 1;
`

export const GraphOverlayNoticeBody = styled.div`
  margin-top: 6px;
  padding: 8px 10px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  background-color: rgba(255, 255, 255, 0.94);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  color: #333;
  font-size: 11px;
  line-height: 1.35;

  @media (max-width: ${styledTheme.breakpoints.sm}px) {
    margin-top: 4px;
    padding: 6px 8px;
    font-size: 10px;
    line-height: 1.3;
  }
`
export const DataTableModalContainer = styled(DataViewModalContainer)`
`
export const TableContainer = styled.div`
  display: inline-flex;
  flex: 1;
  width: 100%;
  overflow: scroll;
`
export const DashboardContainer = styled.div`
  display: block;
  flex-direction: column;
  width: 100%;
  overflow: scroll;
  background-color: #EDEDED;
`
export const CellVerticalPadding = css`
  padding-top: 10px;
  padding-bottom: 10px;
`
export const Table = styled.table`
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-size: 0.875rem;
  border-collapse: collapse;
  margin-bottom: 10px;
  width: 100%;
`
export const THead = styled.thead`
  th:first-child {
    padding-right: 40px;
    max-width: unset !important;
  }
  th:last-child {
    width: 100%;
  }
`
export const TBody = styled.tbody`
  td:first-child {
    padding-right: 40px;
    max-width: unset !important;
  }
  td:last-child {
    width: 100%;
  }
`
export const HeaderRow = styled.tr`
`
export const HeaderCell = styled.th`
  position: sticky;
  top: 0;
  background-color: #FFF;
  text-align: ${({first}) => first ? 'left' : 'center' };
  padding-left: ${({first}) => first ? '0' : '25px' };
  padding-top: 10px;
  padding-bottom: 6px;
  padding-left: 10px;
  padding-right: 10px;
  min-width: 70px;
  max-width: 70px;
  white-space: wrap;
  text-overflow: ellipsis;
`
export const UnitsRow = styled.tr`
`
export const UnitCell = styled.td`
  text-align: ${({first}) => first ? 'left' : 'right' };
  font-weight: ${({bold}) => bold ? '700' : '400'};
  padding-left: ${({first}) => first ? '0' : '0' };
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
  min-width: 70px;
  max-width: 70px;
  white-space: nowrap;
  text-overflow: ellipsis;
`
export const DataRow = styled.tr`
  ${CellVerticalPadding}
  &:nth-child(even) {
    background-color: #EDEDED;
  }
`
export const DataCell = styled.td`
  ${CellVerticalPadding}
  text-align: right;
  border-top: 1px solid #CCC;
  padding-left: 10px;
  padding-right: 10px;
  min-width: 70px;
  max-width: 70px;
  white-space: nowrap;
  text-overflow: ellipsis;
`
export const DataTableFooter = styled.div`
  border-top: 1px solid ${styledTheme.border_grey};
  background-color: white;
  display: inline-flex;
  height: 40px;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  padding: 10px;
`
export const DownloadButton = styled(Button)`
  border-radius: 2px !important;
  min-height: unset !important;
  font-size: 12px !important;
  padding: 4px 8px !important;
`
export const DashboardToolbarContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 1rem 10px;
`
export const DashboardToolbarExpandLink = styled.span`
  padding: 0.4rem 0.6rem;
  background-color: ${styledTheme.colors.button_background};
  color: #FFF;
  border: 1px solid #333;
  text-decoration: none;
  cursor: pointer;
  font-size: 0.8rem;
`
export const DashboardGraphContainer = styled.div`
  padding: 6px;
  width: calc(100% - 20px);
  height: 400px;
  margin: 10px;
  margin-top: 10px;
  border: 1px solid #ADC0BE;
  border-radius: 3px;
  display: flex;
  background-color: #FFF;
  flex-direction: column;
`
export const DashboardGraphHeaderRow = styled.div`
  display: flex;
`
export const DashboardGraphHeadingCell = styled.div`
  display: inline-flex;
  align-items: flex-end;
`
export const DashboardGraphHeading = styled.h3`
  margin: 0.4rem 0 0 0.4rem;
  cursor: pointer;
  font-size: 1rem;
`
export const DashboardGraphExpandLinkRow = styled.div`
  display: flex;
  padding-top: 6px;
  padding-bottom: 6px;
`
export const DashboardGraphExpandLinkCell = styled.div`
  display: inline-flex;
  padding-left: 0.4rem;
  align-items: flex-start;
`
export const DashboardGraphExpandLink = styled.span`
  padding: 2px 4px;
  background-color: ${styledTheme.colors.button_background};
  color: #FFF;
  text-decoration: none;
  cursor: pointer;
  font-size: 0.7rem;
  border-radius: 3px;
  white-space: nowrap;
  ${({allHistory}) => {
    if (allHistory) {
      return `background-color: #FFAA2E;\n
        color: #333;`
    }
  }}
`
export const DashboardGraphInnerContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  flex: 1;
`
function LdsDualRingAnimation() {
  return keyframes`
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  `;
}
export const LdsDualRingSpinnerDefault = styled.div`
  display: inline-block;
  width: 64px;
  height: 64px;
  &:after {
    content: " ";
    display: block;
    width: 46px;
    height: 46px;
    margin: 1px;
    border-radius: 50%;
    border: 5px solid ${styledTheme.colors.loading_spinner_color_grey};
    border-color: ${styledTheme.colors.loading_spinner_color_grey} transparent ${styledTheme.colors.loading_spinner_color_grey} transparent;
    animation: ${LdsDualRingAnimation()} 1s linear infinite;
  }
`
export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 40;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: ${({show}) => show ? 'flex' : 'none'};
  justify-content: center;
  align-items: center;
`

export const NoDataDiv = styled.div`
  padding: 10px;
`
